import React from "react";

const PolicyMetricSection = ({ title, badge, rows, icon }) => {
  return (
    <div className="linked-report__metric-block">
      <div className="linked-report__metric-header">
        {icon && <div className="linked-report__policy-icon">{icon}</div>}
        <h3>{title}</h3>
        <span
          className={`linked-report__status-pill linked-report__status-pill--${badge.variant}`}
        >
          {badge.label}
        </span>
      </div>
      {rows.map((row, index) => (
        <div className="linked-report__row" key={index}>
          <span>{row.label}</span>
          <span className={row.muted ? "linked-report__muted" : ""}>{row.value}</span>
        </div>
      ))}
    </div>
  );
};

export default PolicyMetricSection;
